<template>
  <div class="news-article-item" :class="viewMode">
    <div class="news-img">
      <img v-if="item.url != null" :src="item.url" :alt="truncatedTitle">
      <img v-else src="../../assets/NewsTestImg.png">
    </div>
    <div class="news-text" v-if="item">
      <p class="news-tag">{{ item.dateTime | moment($t("dateFormat")) }}</p>
      <h3><router-link class="news-title-link" :to="{ name: 'news-content', params: { id: this.id } }">{{ item.title }}</router-link></h3>
      <!-- <p v-html="truncatedHtmlContent" class="news-content-p"></p> -->

      <router-link class="card-news-button" :to="{ name: 'news-content', params: { id: this.id } }">{{
        $t("more")}}</router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
  props: ["id", "viewMode"],
  name: "AppHighlightedNewsCard",
  data() {
    return {
      item: null,
      htmlContent: ""
    }
  },
  methods: {
    ...mapActions(["fetchContentById"]),
    loadData() {
      this.fetchContentById(this.id).then((contentResposnse) => {
        // this.item = contentResposnse;
        this.item.title = contentResposnse.title;
        this.htmlContent = contentResposnse.content;
      });
    },
  },
  computed: {
    ...mapGetters(["getContentById", "getSelectedLanguage"]),
    truncatedHtmlContent() {
      const plainText = (this.htmlContent || '').replace(/<[^>]*>/g, '');
      return plainText.length > 50 ? plainText.substring(0, 50) + '...' : plainText;
    },
    truncatedTitle() {
      return this.item.title.length > 40 ? this.item.title.substring(0, 40) + '...' : this.item.title;
    }
  },
  created() {
    this.item = this.getContentById(this.id);
    this.loadData();
  },
  watch: {
    getSelectedLanguage() {
      this.loadData();
    },
    '$route.params.id'() {
      this.loadData();
    }
  },
}
</script>

<style scoped>
.news-article-item {
  border-radius: 15px;
  background-color: var(--light-color);
  padding: 1%;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.news-img {
  width: 100%;
  height: 40% !important;
  max-height: 220px;
  min-height: 220px;
  flex-shrink: 0;
}

.news-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 60%;
  padding-top: 10px;
}

.news-text h3 {
  color: var(--main-color);
  font-size: 24px;
  margin: 0;
  padding: 0;
  flex-grow: 1;
  /* letter-spacing: -1px; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-tag {
  color: #757575;
  margin: 0;
  font-size: 12px;
  line-height: 16px;
}

.news-content-p {
  color: #757575;
  font-size: 18px;
  line-height: 20px;
  margin: 0;
  padding: 0;
  flex-grow: 1;
}


.card-news-button {
  width: 30%;
  align-self: flex-end;
  margin-top: 2%;
  border: 1px var(--main-color) solid;
  background-color: transparent;
  border-radius: 0.5rem;
  color: var(--main-color);
  font-size: 18px;
  text-align: center;
  padding: 10px;
}

.card-news-button:hover {
  background-color: var(--main-color);
  cursor: pointer;
  color: #fff;
  text-decoration: underline;
  text-decoration-color: #fff;
  transition: color 0.3s ease, background-color 0.3s ease;
}

.news-title-link{
  color: var(--main-color);
  text-decoration: none;
}

@media only screen and (max-width: 768px) {
  .card-news-button {
    width: 100%;
    align-self: center;
    padding: 5px;

  }

}
</style>